import React from "react";

import { PaymentMethodForm, Skeleton } from "components";
import { useLoader } from "hooks";
import { useGetPaymentMethodByIdQuery } from "queries";
import { CopyInfoData } from "types";

type EditPaymentMethodFormProps = {
	entityId: string;
	onSuccess: Function;
	submitService: Function;
	paymentMethodId: string;
	paymentMethodQueryKey: string;
	getService: Function;
	copyInfoData?: CopyInfoData;
	isLoadingCopyInfoData?: boolean;
	isApplication?: boolean;
	isBillToAgent?: boolean;
};

export const EditPaymentMethodForm = ({
	entityId,
	onSuccess,
	submitService,
	paymentMethodId,
	paymentMethodQueryKey,
	getService,
	copyInfoData,
	isLoadingCopyInfoData,
	isApplication,
	isBillToAgent,
}: EditPaymentMethodFormProps) => {
	const { data, isLoading }: any = useGetPaymentMethodByIdQuery({
		entityId,
		paymentMethodId,
		paymentMethodQueryKey,
		getService,
	});

	const Loader = useLoader(isLoading);

	return (
		<Loader
			skeleton={<Skeleton height="275px" className="mt-4" />}
			component={
				<PaymentMethodForm
					defaultValues={data}
					isLoading={isLoading}
					entityId={entityId}
					paymentMethodId={paymentMethodId}
					onSuccess={onSuccess}
					submitService={submitService}
					copyInfoData={copyInfoData}
					isLoadingCopyInfoData={isLoadingCopyInfoData}
					isApplication={isApplication}
					isBillToAgent={isBillToAgent}
				/>
			}
		/>
	);
};
